import { render } from "./WorkspaceDataPreviewDialog.vue?vue&type=template&id=41271d6a&ts=true"
import script from "./WorkspaceDataPreviewDialog.vue?vue&type=script&lang=ts"
export * from "./WorkspaceDataPreviewDialog.vue?vue&type=script&lang=ts"

import "./WorkspaceDataPreviewDialog.vue?vue&type=style&index=0&id=41271d6a&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__